import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const VideoWrapper = styled.div`
  margin: 2rem 0;
  width: 100%;

  ${props =>
    props.textwidth &&
    css`
      max-width: 35.625rem;
      margin: 0;
    `};

  @media all and (max-width: 1024px) {
    max-width: 100%;
  }
`;

const StyledVideo = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const StyledVideoText = styled.p`
  font-size: 0.875rem;
  font-weight: 300;
  margin-top: 13px;

  @media screen and (max-width: 64rem) {
    margin: 13px 1.5rem 0;
  }
`;

const VideoBlock = ({ video, videoText, textwidth }) => {
  return (
    <VideoWrapper textwidth={textwidth}>
      <StyledVideo dangerouslySetInnerHTML={{ __html: video }} />
      {videoText && <StyledVideoText>{videoText}</StyledVideoText>}
    </VideoWrapper>
  );
};

VideoBlock.propTypes = {
  video: PropTypes.string.isRequired,
  videoText: PropTypes.string
};

export default VideoBlock;



// WEBPACK FOOTER //
// ./src/components/VideoBlock.js